

import { Box, CircularProgress } from '@mui/material';
import { FC, PropsWithChildren, useContext, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../contexts/auth/AuthContext';

interface IAdminRouteProps extends PropsWithChildren {}

const UNAUTHORIZED = 401;
const FORBIDDEN = 403;
const SERVER_ERROR = 500;
const AUTHORIZED = 200;

const AdminRoute: FC<IAdminRouteProps> = ({
    children
}) => {
    const { user, loading } = useContext(AuthContext);

    const userStatus = useMemo(() => {
        if (!loading) {
            if (!user) {
                return { status: 401 };
            }
            else if (!user.roles?.includes('admin') && !user.roles?.includes('superadmin')) {
                return { status: 403 };
            }
            else return { status: 200 };
        }
        else {
            return undefined;
        }
    }, [loading, user]);

    switch (userStatus?.status) {
        case UNAUTHORIZED: return <Navigate to="/admin/login" />
        case FORBIDDEN: return <Navigate replace to={`/error?error=Forbidden | You do not have the required permissions.`} />
        case SERVER_ERROR: return <Navigate to="/admin/error" />
        case AUTHORIZED: return (
            <Box>
                {children}
            </Box>
        )
        default: (
            <Box>
                <CircularProgress />
            </Box>
        )
    }
}

export default AdminRoute;